import React from 'react'
import { get } from 'lodash';
import PropTypes from 'prop-types';

function CalculationItemExcess({ data }) {
  
  if(get(data, 'type') !== "bpls_tax_revenue_calculation_excess")
    return null

  return (
    <div className="px-1">
      <table className="table table-bordered table-stripped table-sm">
        <thead>
          <tr>
            <th width="150" className="text-right">IN EXCESS OF</th>
            <th width="150" className="text-right">FOR EVERY</th>
            <th width="150" className="text-right">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-dark text-right" width="150">
              {get(data, 'attributes.in_excess_of_human') || '-'}
            </td>
            <td className="text-dark text-right" width="150">
              {get(data, 'attributes.for_every_human') || '-'}
            </td>
            <td className="text-dark text-right" width="150">
              {get(data, 'attributes.amount_human') || '-'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}


CalculationItemExcess.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired
}

export default CalculationItemExcess